export const reviewType = {
  writeable: 'writeable',
  written: 'written'
};

export type ReviewType = keyof typeof reviewType;
